module.exports = __webpack_public_path__ + "img/cases-3.aeb710a0.png";